import React from "react";
import Button from "../../../../../../../common/Button";

const NotepadChangeButton = ( props ) => {

  return (
    <Button className="pen btn-chg-note blue" onClick={ props.onChangeKeypad }>
      <img src={ `${ process.env.PUBLIC_URL }/static/images/icon/keypad/ic_handwrite_blue.svg` } alt="" />
    </Button>
  );

};

export default NotepadChangeButton;
